module.exports = __webpack_public_path__ + "img/symbol_6.ff22c657.png";